// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1f98234d","703":"4c4e2aad"}[chunkId] + ".chunk.js";
};